import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { ArrowLeft, Mail } from "lucide-react";

export function OTPVerification({
  email,
  otp,
  setOtp,
  loading,
  onBack,
  onVerify,
  onResend
}) {
  return (
    <div className="space-y-6">
      <button 
        onClick={onBack}
        className="flex items-center text-gray-600 hover:text-gray-800 transition-colors"
      >
        <ArrowLeft className="h-4 w-4 mr-2" /> Back
      </button>

      <div className="text-center">
        <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
          <Mail className="h-8 w-8 text-blue-600" />
        </div>
        <h2 className="text-2xl font-bold text-gray-900">Verify Your Identity</h2>
        <p className="text-gray-600 mt-2">Enter the 6-digit code sent to <span className="font-medium">{email}</span></p>
      </div>

      <Input
        value={otp}
        onChange={(e) => setOtp(e.target.value.replace(/\D/g, '').slice(0, 6))}
        placeholder="000000"
        className="text-center text-3xl tracking-[0.5em] font-mono"
        maxLength={6}
        data-testid="parent-otp-input"
      />

      <Button 
        onClick={onVerify}
        disabled={loading || otp.length !== 6}
        className="w-full bg-blue-600 hover:bg-blue-700"
        data-testid="parent-verify-otp-btn"
      >
        {loading ? "Verifying..." : "Verify & Login"}
      </Button>

      <p className="text-center text-sm text-gray-500">
        Didn't receive code? <button onClick={onResend} className="text-blue-600 hover:underline">Resend</button>
      </p>
    </div>
  );
}
